import { render, staticRenderFns } from "./url-image.vue?vue&type=template&id=cfa34f5e&"
import script from "./url-image.vue?vue&type=script&lang=ts&"
export * from "./url-image.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports